/**
 * HashMedora Storage Layer
 * Wrapper around localStorage with fallback.
 * Can be swapped with IndexedDB or real backend later.
 */

const STORAGE_PREFIX = 'hashmedora_';

function key(name) {
  return STORAGE_PREFIX + name;
}

export const storage = {
  get: (name, defaultValue = null) => {
    try {
      const raw = localStorage.getItem(key(name));
      if (raw === null) return defaultValue;
      return JSON.parse(raw);
    } catch {
      return defaultValue;
    }
  },

  set: (name, value) => {
    try {
      localStorage.setItem(key(name), JSON.stringify(value));
      return true;
    } catch {
      return false;
    }
  },

  remove: (name) => {
    try {
      localStorage.removeItem(key(name));
      return true;
    } catch {
      return false;
    }
  },

  getList: (name) => {
    return storage.get(name, []);
  },

  push: (name, item) => {
    const list = storage.getList(name);
    list.push(item);
    return storage.set(name, list);
  },

  update: (name, updater) => {
    const current = storage.get(name);
    const updated = updater(current);
    return storage.set(name, updated);
  },
};

export default storage;
